module.exports = __webpack_public_path__ + "static/media/Spinner.2863af0a.svg";